// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"8a3220ab","348":"9d4683bd","349":"2d368da5","534":"60a3d229","787":"8e89d864"}[chunkId] + ".chunk.js";
};